module.exports = __webpack_public_path__ + "img/BlueArrows_right.4dd7fa4b.svg";